module.exports = __webpack_public_path__ + "static/media/bdsr3_.a2806123.svg";